var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Echarts',{attrs:{"option":_vm.baseOption,"height":this.isMobile?'300px':'630px'}})
}
var staticRenderFns = []

export { render, staticRenderFns }